module.exports = __webpack_public_path__ + "img/takeaway_qr_code.e0a4fec3.png";